// react
import { useCallback, useEffect, useRef, useState } from "react";
// classes
import classes from "./BookCloudPage.module.css";
// components
import Layout from "../Layout/Layout";
import SubscriptionsModal from "../UI/Modal/SubscriptionsModal/SubscriptionsModal";

const BookCloudPage = (props) => {
  // props
  const {} = props;

  // state
  const [subscriptionModalVisible, setSubscriptionModalVisible] =
    useState(false);

  // handlers
  const subscriptionModalOpenedHandler = async () => {
    setSubscriptionModalVisible(true);
  };

  // subscription Modal
  const subscriptionModalClosedHandler = () => {
    setSubscriptionModalVisible(false);
  };

  // view
  return (
    <Layout shortHeader>
      <div className={classes.BookCloudPage}>
        <div className={classes.BookCloudPage__Title_btn_Section}>
          <h1 className={classes.BookCloudPage__Title}>ما هو بوكلاود بلاس</h1>
          <button
            className={classes.BookCloudPage__PlansPricesBtn}
            onClick={subscriptionModalOpenedHandler}
          >
            اعرف الخطط
          </button>
        </div>
        <h3>
          اكثر من 1000 كتاب، بأكثر من 20000 جنيه / واكثر من 20 دار نشر/ كل هذا
          باشتراك يبدأ من 70 جنيه مصري في الشهر
        </h3>
        <p>
          هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي
          القارئ عن التركيز على الشكل الخارجي للنص أو شكل توضع الفقرات في الصفحة
          التي يقرأها. ولذلك يتم استخدام طريقة لوريم إيبسوم لأنها تعطي توزيعاَ
          طبيعياَ -إلى حد ما- للأحرف عوضاً عن استخدام "هنا يوجد محتوى نصي، هنا
          يوجد محتوى نصي" فتجعلها تبدو (أي الأحرف) وكأنها نص مقروء. 
        </p>
        <p className={classes.BookCloudPage__Note}>
          <span className={classes.BookCloudPage__asterisk}>*</span>
          الكتب الموجوده في بوكلاودبلاس متاحة للقراءة مجاناً طول فترة
          الاشتراك،مع بقاء امكانية شراء الكتاب ـ ان رغبت ـ للاحتفاظ به في
          المكتبه بصورة دائمة
        </p>
        <SubscriptionsModal
          visible={subscriptionModalVisible}
          close={subscriptionModalClosedHandler}
        />
      </div>
    </Layout>
  );
};

export default BookCloudPage;
